import { jsx as _jsx } from "react/jsx-runtime";

const BowtieLogoSmall = props => {
  return _jsx("svg", {
    width: 53,
    height: 30,
    viewBox: "0 0 53 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false,
    "aria-hidden": false,
    role: "img",
    ...props,
    children: _jsx("path", {
      d: "M6.75 28.8c-1.364.62-2.601.497-3.594-.495C1.67 26.94.678 21.614.678 14.923S1.67 2.904 3.156 1.54C4.15.548 5.386.426 6.75 1.045L26.697 12.07 46.644 1.045c1.364-.62 2.602-.497 3.594.496 1.486 1.363 2.479 6.69 2.479 13.382 0 6.69-.993 12.018-2.479 13.382-.992.992-2.23 1.115-3.594.496L26.697 17.775 6.75 28.8ZM6.502 8.606c-.371 1.116-.497 3.22-.497 6.195s.249 5.08.497 6.195c.248 1.363 1.237 1.486 2.726.496l12.267-6.69L9.354 7.986c-1.612-.867-2.479-.62-2.85.618h-.002Zm40.639 0c-.248-1.363-1.238-1.485-2.727-.618L32.273 14.8l12.267 6.691c1.611.993 2.478.744 2.726-.496.371-1.115.497-3.22.497-6.195-.123-2.975-.371-5.08-.62-6.195h-.002Z",
      fill: "#FF0068"
    })
  });
};

export default BowtieLogoSmall;